/* eslint-disable react/no-danger */
import useItemContext from '@/hooks/useItemContext';
import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import i18next from 'i18n';
import { AnimateChangeInHeight } from '@/components/general/AnimateChangeInHeight';
import { Item } from '@/api';
import style from './ProductDescription.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function LinkRenderer(props: any) {
    const { href, children } = props;
    return (
        <a href={href} target="_blank" rel="noreferrer">
            {children}
        </a>
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ParagraphRenderer(props: any) {
    const { children, node, ...rest } = props;
    if (!children || (typeof children === 'string' && children.trim() === '')) {
        return <br />;
    }
    return (
        <p {...rest}>
            {children}
        </p>
    );
}

const ProductDescription = () => {
    const { item } = useItemContext();
    const [showMore, setShowMore] = useState<boolean>(false);
    const [showMoreAuthentication, setShowMoreAuthentication] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);
    const authenticationRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
    const [authenticationHeight, setAuthenticationHeight] = useState<number>(0);

    useEffect(() => {
        if (ref?.current?.clientHeight) {
            setHeight(ref.current.clientHeight);
        }
    }, [ref?.current?.clientHeight]);

    useEffect(() => {
        if (authenticationRef?.current?.clientHeight) {
            setAuthenticationHeight(authenticationRef.current.clientHeight);
        }
    }, [authenticationRef?.current?.clientHeight]);

    return (
        <div className="w-full max-w-[1040px] mx-auto">
            <div className={clsx('p-[20px] bg-grey16 rounded-[10px] w-full space-y-[20px] overflow-hidden min-h-[305px] relative ', height >= 260 && ' pb-[60px]')}>
                <AnimateChangeInHeight>
                    <div className={clsx(showMore ? 'h-auto' : 'h-[274px]', 'relative')}>
                        <h3 className="text-[16px] font-[500] mb-3">{i18next.t('product-bid.description')}</h3>
                        <span className={clsx('text-[16px] font-[400] leading-[26px] block text-blue12')} ref={ref}>
                            <Markdown
                                components={{
                                    a: LinkRenderer,
                                    p: ParagraphRenderer
                                }}
                                className={style['product-description']}
                                children={item?.description}
                                remarkPlugins={[remarkGfm as any]} />
                        </span>
                    </div>
                </AnimateChangeInHeight>
                {height >= 260 && <button onClick={() => setShowMore(!showMore)} className="absolute bottom-[16px] left-[20px] text-[14px] font-[500] text-blue16">{i18next.t('product-bid.show')} {showMore ? i18next.t('product-bid.less') : i18next.t('product-bid.more')}</button>}
            </div>
            {item?.type !== Item.TypeEnum.NonAuth && (
                <div className={clsx('p-[20px] bg-grey16 rounded-[10px] w-full space-y-[20px] overflow-hidden min-h-[305px] relative mt-5', authenticationHeight >= 260 && ' pb-[60px]')}>
                    <AnimateChangeInHeight>
                        <div className={clsx(showMoreAuthentication ? 'h-auto' : 'h-[274px]', 'relative')}>
                            <h3 className="text-[16px] font-[500] mb-3">{i18next.t('product-bid.authentication')}</h3>
                            <span className={clsx('text-[16px] font-[400] leading-[26px] block text-blue12')} ref={authenticationRef} dangerouslySetInnerHTML={{ __html: i18next.t('product-bid.authentication-description', { interpolation: { escapeValue: false } }) }} />
                        </div>
                    </AnimateChangeInHeight>
                    {authenticationHeight >= 260 && <button onClick={() => setShowMoreAuthentication(!showMoreAuthentication)} className="absolute bottom-[16px] left-[20px] text-[14px] font-[500] text-blue16">{i18next.t('product-bid.show')} {showMoreAuthentication ? i18next.t('product-bid.less') : i18next.t('product-bid.more')}</button>}
                </div>
            )}
        </div>
    );
};

export default ProductDescription;
/* eslint-enable react/no-danger */
